<template>
  <form @submit.prevent="upload" class=" tw-w-full">
    <div class="tw-grid tw-grid-rows-2 tw-gap-y-6">
      <div class="tw-flex tw-w-full">
        <OnboardingGrayBtn title="Skip" class="tw-flex-1 tw-mr-4" />
        <OnboardingBtn
          title="Verify account"
          class="tw-flex-initial"
          @click="$router.push({ name: 'UploadDocument' })"
        />
      </div>
    </div>

    <SelfieModal
      v-if="showSelfieCam"
      @close="showSelfieModal = !showSelfieModal"
    >
      <template v-slot:content>
        <Selfie @fileUpload="uploadSuccess" @uploadFail="uploadFail" />
      </template>
    </SelfieModal>
  </form>
</template>

<script>
  import OnboardingBtn from "@/components/onboarding/OnboardingBtn";
  import OnboardingGrayBtn from "@/components/onboarding/OnboardingGrayBtn";
  import Selfie from "@/components/general/Sefie";
  import SelfieModal from "@/components/general/SmallModal";

  export default {
    name: "UploadSelfieForm",

    components: { OnboardingBtn, OnboardingGrayBtn, Selfie, SelfieModal },

    emits: ["upload"],
    data() {
      return {
        showSelfieCam: false,
      };
    },

    methods: {
      upload() {},
    },
  };
</script>

<style lang="scss" scoped></style>
